import { useEffect, useState } from 'react'
import { Table, Input, DatePicker, Button, Tag, Modal, Form, Segmented } from 'antd'
import type { TableProps } from 'antd'
import dayjs from 'dayjs'
import axios from 'axios'
import AdminReservationDetail from './components/Detail'

const { RangePicker } = DatePicker
type ReservationStatusFilter = 'all' | 'BOOKED' | 'CANCELED'

type ReservationFilterValues = {
  customerName?: string
  plannerName?: string
  shopIds?: string
  reservationStatus?: ReservationStatusFilter
  dateRange?: [dayjs.Dayjs, dayjs.Dayjs] | null
}

type ReservationRow = {
  id: number
  reservationCode: string
  customerName: string
  plannerName: string
  shopNames: string
  reservedTime: string
  firstSlotDate: string
  reservationStatus: 'BOOKED' | 'CANCELED'
  slotCount: number
}

export default function ReservationListPage() {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [reservationModalId, setReservationModalId] = useState<number | null>(null)
  const [data, setData] = useState<ReservationRow[]>([])
  const [total, setTotal] = useState(0)

  const [page, setPage] = useState(1)
  const [rows, setRows] = useState(20)

  const fetchData = async (
    pageArg = page,
    rowsArg = rows,
    filterValues: ReservationFilterValues = form.getFieldsValue()
  ) => {
    setLoading(true)
    try {
      const params = {
        page: pageArg,
        rows: rowsArg,
        customerName: filterValues.customerName || undefined,
        plannerName: filterValues.plannerName || undefined,
        shopIds: filterValues.shopIds || undefined,
        reservationStatus:
          filterValues.reservationStatus === 'all'
            ? undefined
            : filterValues.reservationStatus,
        startDate: filterValues.dateRange?.[0]?.format('YYYY-MM-DD'),
        endDate: filterValues.dateRange?.[1]?.format('YYYY-MM-DD')
      }

      const res = await axios.get('/api/admin/reservations', { params })
      console.log(res)
      setData(res.data.data.list)
      setTotal(res.data.data.totalCount)
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [page, rows])

  const handleSearch = (values: ReservationFilterValues) => {
    setPage(1)
    fetchData(1, rows, values)
  }

  const handleValuesChange = (
    changedValues: Partial<ReservationFilterValues>,
    values: ReservationFilterValues
  ) => {
    if (changedValues.reservationStatus) {
      setPage(1)
      fetchData(1, rows, values)
    }
  }

  const columns: TableProps<ReservationRow>['columns'] = [
    {
      title: '예약코드',
      dataIndex: 'reservationCode',
      width: 160,
      render: (reservationCode, { id }) => {
        return (
          <a onClick={() => setReservationModalId(id)}>{reservationCode}</a>
            
        )
      }
    },
    {
      title: '고객명',
      dataIndex: 'customerName',
      width: 100,
      ellipsis: true,
      align: 'center'
    },
    {
      title: '플래너',
      dataIndex: 'plannerName',
      width: 100,
      ellipsis: true,
    },
    {
      title: '업체',
      dataIndex: 'shopNames',
      width: 200
    },
    {
      title: '예약일',
      dataIndex: 'reservedTime',
      width: 180,
      render: v => dayjs(v).format('YYYY-MM-DD HH:mm')
    },
    {
      title: '투어일',
      dataIndex: 'firstSlotDate',
      width: 120
    },
    {
      title: '상태',
      dataIndex: 'reservationStatus',
      width: 100,
      align: 'center',
      render: (reservationStatus) => {
        if (reservationStatus === 'BOOKED') {
          return <Tag color='green'>예약됨</Tag>  
        }
        return <Tag color='red'>취소</Tag>
      }
    },
    {
      title: '슬롯수',
      dataIndex: 'slotCount',
      width: 80
    }
  ]
  const closeDetailModal = () => {
    setReservationModalId(null)
  }
  return (
    <div>
      {/* 필터 */}
      <Form
        form={form}
        layout="inline"
        initialValues={{
          customerName: '',
          plannerName: '',
          shopIds: '',
          reservationStatus: 'all',
          dateRange: null
        }}
        onFinish={handleSearch}
        onValuesChange={handleValuesChange}
      >
        <Form.Item name="customerName">
          <Input placeholder="고객명" style={{ width: 120 }} />
        </Form.Item>

        <Form.Item name="plannerName">
          <Input placeholder="플래너명" style={{ width: 120 }} />
        </Form.Item>

        {/* <Form.Item name="shopIds">
          <Input placeholder="shopIds (1,2,3)" style={{ width: 160 }} />
        </Form.Item> */}

        

        <Form.Item name="dateRange">
          <RangePicker placeholder={['투어일 시작', '투어일 마지막']} />
        </Form.Item>
        <Form.Item name="reservationStatus">
          <Segmented
            style={{border: '1px solid rgb(217, 217, 217)'}}
            options={[
              { label: '전체', value: 'all' },
              {
                label: <span style={{ color: '#389e0d' }}>예약됨</span>,
                value: 'BOOKED'
              },
              {
                label: <span style={{ color: '#cf1322' }}>취소</span>,
                value: 'CANCELED'
              }
            ]}
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            검색
          </Button>
        </Form.Item>
      </Form>

      {/* 테이블 */}
      <Table
        rowKey="id"
        loading={loading}
        columns={columns}
        dataSource={data}
        pagination={{
          current: page,
          pageSize: rows,
          total,
          onChange: (p, r) => {
            setPage(p)
            setRows(r)
          }
        }}
      />
      {reservationModalId && (
        <Modal 
          open
          width={800}
          onCancel={closeDetailModal}
        >
          <AdminReservationDetail
            reservationId={reservationModalId}
            onClose={closeDetailModal}
          />
        </Modal>
      )}
    </div>
  )
}
